export enum ROUTES_AUTH {
  LOGIN = 'login'
}
